import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { CompanyId } from "~/context/Company/domain/CompanyId";
import { ReveniuSubscriptionRepository } from "../domain/ReveniuSubscriptionRepository";
import { ReveniuSubscriptionId } from "../domain/ReveniuSubscriptionId";
import { SubscriptionId } from "~/context/Subscriptions/domain/SubscriptionId";

export async function addReveniuSubscription(
  repository: ReveniuSubscriptionRepository,
  subscriptionId: string,
  companyId: string,
  type: string,
): Promise<VectiResult> {
  const myCompanyId = new CompanyId(companyId);
  const mySubscriptionId = new SubscriptionId(subscriptionId)
  const myReveniuSubscriptionId = ReveniuSubscriptionId.random();
  try {
    console.log("myReveniuSubscriptionId, mySubscriptionId, myCompanyId, type:" + myReveniuSubscriptionId + "/" + mySubscriptionId + "/" + myCompanyId + "/" + type);
    const result = await repository.addReveniuSubscription(myReveniuSubscriptionId, mySubscriptionId, myCompanyId, type);
    console.log("addSubscription", JSON.stringify(result));
    const returnValue = {
      uid: myReveniuSubscriptionId.toString(),
      reveniu_id: result.reveniu_id.toString(),
      completion_url: result.completion_url.toString(),
      security_token: result.security_token.toString()
    };
    return new VectiResult(true, JSON.stringify(returnValue));
  } catch (error) {
    console.log("error addSubscription:" + error);
    return new VectiResult(false, "Error");
  }
}
